export const onlyNumbers = (str?: string | null): string =>
  (str || '').replace(/[^0-9]+/g, '')
